import { isBoolean, isString } from './is';

/**
 * 将任意值安全转换为数字，无法解析时返回 0
 * @param val - 待转换的值
 */
export const toNumber = (val: number | string | boolean | undefined | null): number => {
  // == null 同时匹配 null 和 undefined
  if (val == null) return 0;

  if (isString(val)) {
    const parsed = parseFloat(val);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  if (isBoolean(val)) return Number(val);

  return val;
};

/** 将数值限制在 [min, max] 范围内 */
export const clamp = (num: number, min: number, max: number) => Math.min(max, Math.max(min, num));

/** 将索引限制在数组有效下标范围 [0, arr.length - 1] 内 */
export const clampArrayRange = (index: number, arr: readonly unknown[]) => clamp(index, 0, arr.length - 1);
